import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

import { Button } from "../ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

import DefaultImg from "@/assets/images/photos/YouSure.svg";
import {
  ALERT_BUTTONS,
  ALERT_MESSAGES,
} from "@/constants/customAlert.constants";
import { cn } from "@/lib/utils";

interface AldAlertProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  btnName?: string;
  cancelName?: string;
  btnAction?: () => void;
  cancelAction?: () => void;
  title?: string;
  desc?: string;
  img?: string;
  imgSize?: number;
  customElement?: React.ReactNode;
  showImg?: boolean;
  className?: string;
  footerElementAttr?: {
    className?: string;
    order?: "first" | "last";
  };
  node?: {
    className?: string;
    node: React.ReactNode;
  };
}

const CustomAlert: React.FC<AldAlertProps> = ({
  isOpen,
  setIsOpen,
  title,
  btnName,
  cancelName,
  btnAction,
  cancelAction,
  desc,
  img,
  imgSize,
  customElement,
  showImg = true,
  footerElementAttr = {
    order: "first",
  },
  node,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className={cn(node?.className, "w-[450px] py-4")}>
        <VisuallyHidden>
          <DialogTitle />
          <DialogDescription />
        </VisuallyHidden>
        {node ? (
          node?.node
        ) : (
          <>
            <DialogHeader>
              {showImg && (
                <img
                  src={img ? img : DefaultImg}
                  className={`${img ? `size-[${imgSize}px]` : "w-4/5 h-[11/12] "} self-center`}
                />
              )}
            </DialogHeader>
            <div className='text-center'>
              <h2 className='pb-2 text-2xl text-semibold text-aldgray'>
                {title?.length ? title : ALERT_MESSAGES.TITLE}
              </h2>
              <p className='text-base text-aldgray opacity-70'>
                {desc?.length ? desc : ALERT_MESSAGES.DESC}
              </p>
              {customElement && customElement}
            </div>
          </>
        )}
        <DialogFooter className='mt-6'>
          <div
            className={cn(
              "w-full flex flex-col gap-2 items-center",
              footerElementAttr?.className,
            )}
          >
            <DialogClose asChild>
              <Button
                onClick={() => btnAction && btnAction()}
                className={cn(
                  "w-4/5",
                  footerElementAttr?.order === "first"
                    ? "order-1"
                    : "order-last",
                )}
              >
                {btnName?.length ? btnName : ALERT_BUTTONS.YES}
              </Button>
            </DialogClose>
            <DialogClose asChild>
              <Button
                variant={"ghost"}
                className='order-1 w-4/5 border-0 ring-0 hover:border'
                onClick={() => cancelAction && cancelAction()}
              >
                {cancelName?.length ? cancelName : ALERT_BUTTONS.NO}
              </Button>
            </DialogClose>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CustomAlert;
